module.exports = __webpack_public_path__ + "img/warn_08.58f4c2a3.png";